import { useQuery, UseQueryResult } from 'react-query';
import { SalesPortalConfiguration } from 'types';
import { client } from 'utils/api-client';

function useSalesPortalConfiguration(
  salesPortalConfigurationId: string | undefined,
): UseQueryResult<{ data: SalesPortalConfiguration }> {
  return useQuery(
    ['salesPortalConfigurations', salesPortalConfigurationId],
    () => client.get(`sales-portal-configurations/${salesPortalConfigurationId}/`),
    {
      enabled: !!salesPortalConfigurationId,
    },
  );
}

export default useSalesPortalConfiguration;
